import React from 'react';
import { Box, Stack } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';
import { Paper } from '../../../../../../common/components/Paper/Paper';
import { IVideoLeftColumnProps } from './types';
import { ytElementId } from '../../../../../types/common';
import { CaptionsHOC } from '../../../CaptionsContainer/Captions/hocs/CaptionsHOC';
import { SAVED_PHRASES_PANEL_TITLE } from '../../../../../../common/wordings';
import { ButtonIconGrey } from '../../../../../../common/components/ButtonIconGrey/ButtonIconGrey';
import { ArrowIcon } from '../../../../../../../icons/ArrowIcon';

export function VideoLeftColumn({
	onInit,
	onClickHidePanel,
}: IVideoLeftColumnProps) {

	React.useEffect(() => {
		onInit();
	}, []);

	return (
		<Paper
			className={'video-left-column'}
			sx={{
				height: 1,

				width: '33%',
				minWidth: theme.spacing(38),
				maxWidth: theme.spacing(42),

				[theme.breakpoints.up('xl')]: {
					minWidth: theme.spacing(49),
					maxWidth: theme.spacing(49),
				}
			}}
		>
			<Stack
				gap={1}
				sx={{
					height: '100%',
				}}
			>
				<Stack gap={1}
					sx={{
						p: theme.spacing(1, 2, 0),
					}}
				>
					<Stack
						direction={'row'}
						sx={{
							justifyContent: 'space-between',
							alignItems: 'center',
							width: '100%',
						}}
						gap={theme.spacing(1)}
					>
						<Box
							sx={{
								fontSize: theme.typography.subtitle2,
								fontWeight: 600,

								[theme.breakpoints.up('xl')]: { // same as VideoLeftColumn
									fontSize: theme.typography.h6,
									fontWeight: 600,
								}
							}}
						>
							{SAVED_PHRASES_PANEL_TITLE}
						</Box>
							
						<ButtonIconGrey
							sx={{
								width: theme.spacing(3.5),
								height: theme.spacing(3.5),
								borderRadius: '50%',
								color: theme.palette.common.white,
								background: theme.palette.grey[500],

								'.MuiSvgIcon-root': {
									width: theme.spacing(2),
									height: theme.spacing(1.5),
									transform: 'rotate(180deg)',
								},
							}}
							onClick={onClickHidePanel}
						>
							<ArrowIcon />
						</ButtonIconGrey>
					</Stack>

					<Box
						id={ytElementId}
						sx={{
							aspectRatio: 16/9,
							width: 1,
							height: 1,
							zIndex: 0,
							borderRadius: theme.spacing(.75),
						}}
					/>
				</Stack>

				<CaptionsHOC />
			</Stack>
		</Paper>
	);
};
